/* Shopora España · cuenta atrás con fecha real.
   La barra se oculta sola cuando termina la promoción (no se reinicia por visita). */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function initCountdown(el) {
    if (el.dataset.spReady) return;
    el.dataset.spReady = '1';
    var end = Date.parse(el.dataset.end || '');
    var start = Date.parse(el.dataset.start || '');
    if (isNaN(end)) { el.hidden = true; return; }

    var parts = {
      d: el.querySelector('[data-unit="d"]'),
      h: el.querySelector('[data-unit="h"]'),
      m: el.querySelector('[data-unit="m"]'),
      s: el.querySelector('[data-unit="s"]')
    };
    var timer;

    function tick() {
      var now = Date.now();
      if (!isNaN(start) && now < start) { el.hidden = true; return; }
      var diff = end - now;
      if (diff <= 0) {
        clearInterval(timer);
        el.hidden = true;
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (parts.d) {
        parts.d.textContent = d + 'd';
        parts.d.hidden = d === 0;
      }
      if (parts.h) parts.h.textContent = pad(h) + 'h';
      if (parts.m) parts.m.textContent = pad(m) + 'm';
      if (parts.s) parts.s.textContent = pad(s) + 's';
      el.hidden = false;
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-sp-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Editor de temas: re-inicializa al cargar/editar secciones
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
